var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-new analytic chart"},[_c('Toolbar'),_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"col col--full-width"},[_c(_vm.$route.params.chartId,{tag:"component"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }